export default __webpack_public_path__ + "static/media/4.aeb3f7f4.png";